const cancel = 'Prekliči'
const save = 'Shrani'

export default {

  global: {
    generalError: 'Oh škoda! Vaše zahteve ni bilo mogoče obdelati. Prosimo, ponovno naložite to stran.',
    signature: 'Lep pozdrav,',
  },

  component: {
    actionBar: {
      actions: 'Actions',
      hideActions: 'Hide actions',
      next: 'Next',
      previous: 'Previous',
    },

    addButton: {
      add: 'Add',
    },

    aiSummaryBox: {
      transcript: 'Transcript',
      summary: 'Summary',
    },

    attachments: {
      add: 'Dodaj CV ali druge zahtevane priloge',
      placeholderWithDescription: 'Dodaj zahtevane priloge',
      remove: 'Odstrani',
      allowedFileTypes: 'Dovoljene vrste datotek',
      errors: {
        size: 'Datoteka je prevelika, največja dovoljena velikost datoteke je 5MB.',
        empty: 'Datoteka ne vsebuje podatkov',
        invalidType: fileType => `Datoteke vrste ${fileType} žal niso dovoljene iz varnostnih razlogov.`,
        typeNotWhitelisted: 'Ta vrsta datoteke žal ni dovoljena.',
      },
    },

    agreeTos: {
      privacyLinkText: 'Pravilnik o zasebnosti ',
      termsLinkText: 'Pogoje in določila',
      privacyPolicyText: 'Cenimo vašo zasebnost, zato preberite naš ',
      termsText1: 'Preberite in sprejmite ',
      termsText2: 'preden nam posredujete svoje osebne podatke.',
      privacyLink: 'https://get.recright.com/privacy-policy',
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyInfo: mail => `Če ne želite, da obdelujemo vaše osebne podatke, lahko prosite za odstranitev, tako da nam pošljete sporočilo na ${mail}.`,
      customSupportPrivacyInfo: link => `Če ne želite, da obdelujemo vaše osebne podatke, lahko prosite za odstranitev tako, da kontaktirate na ${link}.`,
    },

    buttons: {
      close: 'Zapri',
    },

    competencies: {
      addCompetency: 'Add a new competency',
      edit: 'Edit competencies',
      done: 'Done',
      defaultsDescription: 'If you are unsure what competencies to use, we have defined some good defaults to start with.',
      getDefaults: 'Get default competencies',
    },

    competency: {
      warning: 'Remove competency and all its ratings?',
    },

    confirmDelete: {
      delete: 'Delete',
      cancel: 'Cancel',
      confirm: 'Confirm',
    },

    confirm: {
      cancel: 'Odstrani posnetek',
      confirm: 'Poskusi ponovno',
    },

    confirmButton: {
      wait: count => `Počakajte ${count}`,
      confirm: 'Potrdi',
    },

    controlStatus: {
      text: {
        empty: 'Izpolni',
        valid: () => 'Pripravljeno',
      },
      textarea: {
        empty: 'Izpolni',
        valid: (length, limit) => `${length}/${limit}`,
      },
      select: {
        empty: 'Nastavi',
        valid: () => 'Pripravljeno',
      },
      file: {
        empty: 'Izberi',
        valid: () => 'Spremeni',
      },
      list: {
        empty: 'Dodaj',
        valid: (length, limit) => `${length}/${limit}`,
      },
      search: {
        empty: 'Iskanje',
        valid: () => 'Pripravljeno',
      },
    },

    cookieConsentModal: {
      title: 'Naše spletno mesto uporablja piškotke.',
      body: 'Če sprejmete vse piškotke, se strinjate s shranjevanjem piškotkov v vaši napravi za izboljšanje navigacije po spletnem mestu, analizo uporabe spletnega mesta in pomočjo pri trženju.',
      learnMoreLinkText: 'Več o tem, kako uporabljamo piškotke na',
      learnMoreLink: 'https://get.recright.com/cookies/', // TODO add localized links when the page is translated
      manageCookies: 'Nastavitev piškotkov',
      acceptAll: 'Sprejmi vse piškotke',
      manageTitle: 'Upravljanje privolitev',
      necessaryCookiesTitle: 'Nujno potrebni piškotki',
      necessaryCookiesBody:
        'Ti piškotki so nujni za delovanje spletne strani in jih ni mogoče izklopiti.',
      performanceCookiesTitle: 'Piškotki za boljše delovanje strani',
      performanceCookiesBody:
        'Ti piškotki nam omogočajo štetje obiskov in virov prometa, da lahko merimo in izboljšamo delovanje našega spletnega mesta.',
      confirmChoices: 'Potrdi mojo izbiro',
      marketingCookiesTitle: 'Oglaševalni piškotki',
      marketingCookiesBody:
        'Ti piškotki nam omogočajo prilagajanje in merjenje uspešnosti oglasov.',
      functionalCookiesTitle: 'Funkcionalni piškotki',
      functionalCookiesBody:
        'Ti piškotki se uporabljajo za izboljšanje funkcionalnosti spletnega mesta. Brez teh piškotkov nekatere funkcije morda ne bodo na voljo. Primeri funkcionalnih piškotkov vključujejo storitve spletnega klepeta in uporabniške nastavitve.',
    },

    emailAddresses: {
      candidateNamePlaceholder: 'Candidate name',
      remove: 'Odstrani',
      importCsv: 'Import CSV',
      invalidEmails: 'Invalid emails found.',
      maxCsvEntryErrorNotification: amount =>
        `Max ${amount} csv entries allowed`,
      importCsvTooltip:
        'The csv rows can have email or email,phone. Each row represents a recipient. The phone numbers needs to be in international format (E.164) e.g. (<strong>+358</strong>50xxxxxxx).',
    },

    emailDeliveryStatus: {
      Undetermined: {
        Undetermined: 'Email bounced back. Make sure the recipient received your message.',
      },
      Permanent: {
        General: 'Email delivery failed. Recipients email provider rejected the message.',
        NoEmail: 'Email address does not exist.',
        Suppressed: 'Email was not delivered due to previous unsuccessful delivery attempts.',
      },
      Transient: {
        General: 'Email bounced back. Make sure the recipient received your message.',
        MailboxFull: 'Recipient inbox is full.',
        MessageTooLarge: 'The message content is too large.',
        ContentRejected: 'The message content rejected.',
        AttachmentRejected: 'The attachment rejected.',
      },
    },

    smsDeliveryStatus: {
      notDelivered: 'SMS message added to message queue, waiting for delivery.',
      failed: 'Sending SMS message failed.',
      duplicate: 'The number given is already attatched to a candidate in the interview.',
    },

    error403: {
      heading: 'Prepovedano',
      content: 'Naš strežnik je vljudno (toda odločno) zavrnil izpolnitev zahteve, ki jo je opravil vaš brskalnik. Upoštevajte, da lahko Recright uporabljate na eni sami napravi/brskalniku (naenkrat).',
      link: 'Prva stran',
    },

    error404: {
      heading: 'Tukaj ni ničesar',
      content: 'Iskali smo po svojih najboljših močeh, toda na zahtevanem naslovu ni spletne strani. Morda ste obiskali povezavo, ki je potekla, ali pa ste pomotoma vnesli napačen naslov.',
      link: 'Prva stran',
    },

    error410: {
      heading: 'Zaprto',
      content: 'Delovnega mesta ni mogoče prikazati, ker je zaprto, ali pa se je končalo obdobje za prijave.',
      link: 'Prva stran',
    },

    calendarError: {
      heading: 'Connecting calendar failed',
      content: 'We were unable to connect your calendar. Please try again later and if the issue continues please contact our support.',
    },

    flash: {
      starting: 'Inicializacija…',
      connection_error_hint: 'Omrežne povezave ni bilo mogoče vzpostaviti.\nPoskusite ponovno naložiti to stran.',
      permission_hint: 'Tej strani morate dovoliti uporabo vaše spletne kamere in mikrofona.',
      searching_camera_hint: 'Iskanje spletne kamere…',
      camera_reserved_hint: 'Druga aplikacija ali spletna stran je rezervirala vašo spletno kamero.\nProsimo, zaprite to aplikacijo in ponovno naložite to stran.',
      camera_reserved_hint_chrome_extra: '\nDragi Chrome uporabnik, aplikaciji Recright morate prek dialoga pod vrstico z naslovom omogočiti uporabo spletne kamere.',
      no_camera_hint: 'Spletne kamere ni bilo mogoče najti.',
      no_mic_hint: 'Mikrofona ni bilo mogoče najti.',
      uploading_text: 'Nalaganje …',
      rtmpt_in_use: 'Ta korak ne bi bil potreben, če bi vaš administrator spletnih strani omogočal RTMP. Vprašajte nas kako.',
      preview_text: 'Spletna kamera je v načinu predogleda',
      close_text: 'Zapri kamero',
      remove_text: 'Odstrani posnetek',
      noflash_errortext_install: link => `Kot kaže nimate nameščenega vtičnika Adobe Flash Player. Za zajemanje videoposnetkov potrebujete flash vtičnik. Prejmite flash tukaj: ${link}`,
      noflash_errortext_enable: link => `V primeru, da ste že namestili flash, toda še vedno vidite sporočilo. Obiščite povezavo: ${link}`,
      noflash_errortext_differentbrowser: 'Namesto tega lahko poskusite z brskalnikom, ki podpira HTML5 snemanje. Priporočamo Chrome ali Firefox.',
    },

    footer: {
      terms: 'Pogoji',
      license: 'General Terms of Service',
      privacyPolicy: 'Izjava o varovanju zasebnosti',
      customSupport: link => `Kontaktirajte ${link}`,
      accessibilityReport: 'Accessibility report',
    },

    feedbackPulse: {
      howWouldYouRateInterview: 'Kako bi ocenili svojo izkušnjo z razgovorom?',
      howWouldYouRateJobAd: 'Kako bi ocenili svojo izkušnjo z aplikacijo?',
      yourResponseIsAnonymous: 'Vaš odgovor je anonimen.',
      thankYouFeedback: 'Hvala za vaše povratne informacije!',
    },

    candidateFooter: {
      termsLink: 'https://get.recright.com/recright-terms-and-conditions-candidate',
      privacyPolicyLink: 'https://get.recright.com/privacy-policy',
      accessibilityReportLink: 'https://websitemedia.recright.com/wp-content/uploads/2024/11/06112306/accessibility_report.pdf',
    },

    formErrors: {
      typeNotWhitelisted: 'Ta vrsta datoteke žal ni dovoljena.',
      isRequired: 'To polje je obvezno.',
      isEmail: value => `${value} ni veljaven e-poštni naslov.`,
      isDate: value => `${value} ni veljaven datum.`,
      invalidUrl: 'URL naslov ni veljaven.',
      singleHireEndError: 'Enkratna zaposlitev ne more biti v veljavi več kot 60 dni.',
      isNotTooOldForLive: 'Datum je v preteklosti.',
      isNotAfterEndDate: 'The date is after the date the job ad closes.',
      isValidMobilePhone: value => `${value ? `${value} is not` : 'Not'} a valid mobile phone number.`,
      isInternationalPhoneNumber: 'Phone number must be in international format.',
      duplicateNumber: 'Phone number has already been added.',
      duplicateCompetency: 'Competency with that name already exists',
      isNotDuplicateTemplateName: 'Template with that name already exists',
    },

    jobAdApplication: {
      name: 'Ime',
      city: 'Kraj bivanja',
      email: 'E-naslov',
      phone: 'Telefonska številka',
      applyForPosition: 'Prijavi se na delovno mesto',
      back: 'Nazaj',
      continue: 'Nadaljuj',
      submit: 'Pošlji',
      saveForLater: 'Nadaljuj kasneje',
      namePlaceholder: 'Vnesite svoje ime',
      emailPlaceholder: 'Vnesite svoj e-poštni naslov',
      phonePlaceholder: 'Vnesite svojo telefonsko številko',
      cityPlaceholder: 'Vnesite svoje trenutno mesto',
      links: 'Dodajte povezave, na primer svoj LinkedIn profil',
      legendBasicInfo: 'Osnovne informacije',
      legendLinks: 'Povezave',
      legendAttachments: 'Priloge',
      legendAdditionalFields: 'Dodatne informacije',
      coverLetter: 'Spremno pismo',
      attachments: 'Priloge',
      introduction: 'Tukaj napišite kratko predstavitev o sebi',
      thankYou: 'Hvala.',
      luck: 'Veliko sreče!',
      close: 'Zapri',
      required: 'Predmeti, označeni z * zvezdico so obvezni.',
    },

    jobAdContainer: {
      endTime: date => (date ? `odprto do ${date}` : ''),
    },

    jobAdDetails: {
      apply: 'Prijavi se za delo',
    },

    jobAdQuickInterview: {
      back: 'Nazaj',
      submit: 'Pošlji',
      saveForLater: 'Nadaljuj kasneje',
      title: 'Hitri video razgovor',
      description: 'Ker vas želimo hitreje spoznati, vas vabimo, da hitro odgovorite na naše kratko vprašanje za razgovor. S seboj prinesite svojo osebnost in svoji prijavi dodajte dušo.',
      requiredNote: 'Upoštevajte, da je to en del postopka in bo zaposlitveni agent vašo prijavo prejel šele, ko navedete svoj odgovor.',
      reminderNote: 'Odgovor lahko navedete nemudoma, ali pa nadaljujete kasneje, tako da prejmete opomnik na vaš e-poštni naslov.',
    },

    jobAdRow: {
      responses: 'Prijave',
      status: {
        open: 'Odprte',
        filled: 'Zapolnjene',
        cancelled: 'Preklicane',
        done: 'Končane',
        close: 'Zapri',
        draft: 'Zaprte (osnutek)',
        hidden: 'Skrite',
      },
    },

    interviewRow: {
      responses: 'Kandidati',
    },

    linkedInProfile: {
      showLinkedInProfileModal: 'Prikaži LinkedIn profil',
    },

    linkedInButton: {
      error: 'Napaka pri pridobivanju profila. Prosimo, poskusite znova.',
      buttonText: 'Prijavi se s profilom LinkedIn',
    },

    linkedInContainer: {
      linkedInButtonDescription: 'Svoj LinkedIn profil lahko uporabite za samodejno izpolnitev obrazca',
      linkedInOr: 'Ali',
      error: 'Napaka pri pridobivanju profila. Prosimo, poskusite znova.',
    },

    linkListInput: {
      addField: 'Dodaj',
      removeField: 'Odstrani',
      invalidUrl: 'URL naslov ni veljaven.',
    },

    liveRoom: {
      greeting: name => `Hello, ${name}.`,
      notYetStarted: startTime =>
        `The interview has not yet started. The interview starts at ${startTime}.`,
      interviewTitle: title => `Interview title: ${title}`,
      interviewStartsIn: timeLeft => `The Interview starts in: ${timeLeft}`,
      interviewHasEnded: 'The interview has ended.',
      youHaveLeft: 'You have left the interview.',
      rejoinInterview: 'Rejoin interview',
      joinInterview: 'Join interview',
      goToEvaluations: 'Continue to evaluation',
      structuredInterview: {
        timeEstimateText: timeEstimate => `${timeEstimate} minutes`,
        guideNotesPlaceHolder: stepTitle => `Notes for ${stepTitle}`,
        goToNextStepButtonText: 'Go to next section',
        totalTime: 'Total time in interview:',
        timeIn: partName => `Time in ${partName}:`,
        nextStep: stepTitle => `Next up: ${stepTitle}`,
      },
    },

    loadingButton: {
      loading: 'Nalaganje…',
      saving: 'Shranjevanje…',
      sending: 'Pošiljanje…',
    },

    modalApplicationForm: {
      applyForPosition: 'Prijavite se na delovno mesto',
      continue: 'Nadaljuj',
      name: 'Vnesite svoje ime',
      email: 'Vnesite svoj e-poštni naslov',
      phoneNumber: 'Vnesite svojo telefonsko številko',
      links: 'Vnesete lahko povezave',
      legendLinks: 'Povezave',
      legendAttachments: 'Priloge',
      coverLetter: 'Spremno pismo',
      attachments: 'Priloge',
      introduction: 'Tukaj napišite predstavitev o sebi',
      thankYou: 'Hvala.',
      luck: 'Veliko sreče!',
      close: 'Zapri',
    },

    modalConfirm: {
      cancel,
      confirm: 'V redu',
    },

    modalAlert: {
      close: 'Close',
    },

    modalLinkShare: {
      title: 'Deljiva javna povezava',
      info: 'Tukaj najdete javni naslov oglasa za delovno mesto, ki ga lahko delite.\nVsakdo, ki ga delovno mesto zanima, lahko vidi oglas \nin se odloči za prijavo.\nOb prvih prejetih prijavah boste prejeli običajno obvestilo.\n\nTukaj najdete javno povezavo do oglasa za delovno mesto:',
    },

    modalVideoAdd: {
      title: 'Dodaj nov video',
      chooseTitle: 'Dodaj nov video',
      titlePlaceholder: 'Vnesite naslov videoposnetka',
      cancel,
      save,
    },

    modalVideoUpload: {
      title: 'Naloži nov video',
      info: 'Največja dovoljena velikost je 500mb. Priporočamo, da videoposnetke pred nalaganjem stisnete, tako da nalaganje in pretvarjanje trajata manj časa.',
    },

    modalCandidateInfo: [
      {
        headline: 'Posnemite svoj video odgovor, ',
        content: 'tolikokrat kot želite. Videoposnetki bodo po snemanju nemudoma shranjeni, vi pa se lahko v video razgovor vrnete prek povezave, ki ste jo prejeli na svoj e-poštni naslov.',
        mobileContent: 'tolikokrat kot želite. Dodajte video v razgovor. Videli boste, kako se video nalaga in shranjuje v razgovor. Na video razgovor se lahko vrnete prek povezave, ki ste jo prejeli na svoj e-poštni naslov. <br><br><strong>Če je vaš video zaslon še vedno črn in uporabljate mobilno napravo Apple, lahko težavo rešite s pomočjo navodil, ki so <a style="text-decoration: underline;" target="_blank" rel="noopener noreferrer" href="https://support.recright.com/en/articles/11187-recording-doesn-t-work-with-ipad-iphone">tukaj</a>.</strong>',
      },
      {
        headline: 'Po snemanju, ',
        content: 'zagotovite, da se video pravilno predvaja in je vaš glas razločen. Ko pritisnete gumb „Pošlji“, bo vaš odgovor zaklenjen in ga ne boste mogli več urejati.',
      },
      {
        headline: 'Ko končate z razgovorom, ',
        content: 'pritisnite gumb „Pošlji odgovore in zaključi razgovor“. Po tem se ne morete več vrniti na video razgovor. V primeru, da želite zapreti to stran in z razgovorom nadaljevati kasneje, pritisnite gumb „Nadaljuj kasneje“.',
      },
      {
        headline: 'Če potrebujete pomoč ',
        content: mailto => `pri odgovarjanju na video razgovor, kliknite gumb „pomoč“ na spodnji desni strani, ali nam pošljite e-pošto na naslov ${mailto}.`,
        customContent: link => `Kontaktirajte ${link}`,
      },
    ],

    navigationBar: {
      back: 'Nazaj',
      dashboard: 'Nadzorna plošča',
      frontpage: 'Prva stran',
    },

    personDetails: {
      stage: 'Stage',
      namePlaceholder: 'Candidate',
      contact: 'Contact',
      links: 'Links',
      attachments: 'Attachments',
      coverLetter: 'Cover Letter',
      referrer: 'Origin',
      referrerInfo: 'The website from which the candidate came to the service.',
      noStage: 'Not in any stage yet',
      lastSeen: time => `Last seen ${time}.`,
      headerAdditionalInformation: 'Additional information',
      state: {
        invited: 'Invited',
        visited: 'Visited',
        incomplete: 'Incomplete',
        completed: 'Completed',
      },
      notVisited: 'Hasn\'t yet visited the interview.',
      scheduledInterview: 'Scheduled interview',
      scheduledInterviewInvitationSent: 'Invited to a meeting',
      scheduledInterviewInvitationExpired: 'Invitation has expired',
      scheduledInterviewInvitationEventCreated: 'Meeting:',
      scheduledInterviewReScheduleMeeting: 'Reschedule meeting',
      otherPersons: count => `Also found on ${count} other positions`,
    },

    phoneInput: {
      placeholder: example => `Telefonska številka v obliki ${example}`,
    },

    questionsAndResponses: {
      response: 'Response',
      noResponse: 'No response',
      resetQuestionResponse: 'Delete candidate response',
      resetQuestionResponseConfirm: questionTitle =>
        `Are you sure you want to reset the question "${questionTitle}" for the candidate and delete their response?`,
      resetQuestionResponseConfirm2: 'If you do this, candidate can retake this question.',
      aiInsights: 'AI Insights',
      showQuestion: 'Show question video',
      hideQuestion: 'Hide question video',
      question: 'Question',
      nonAnswerableInfo: 'Question is non-answerable.',
      evaluationCriteriaLabel: 'Evaluation criteria',
    },

    rating: {
      ownVote: 'Your rating',
      yourVotePlaceholder: 'You have not voted yet.',
      totalVotes: count => `Total ${count} ratings`,
      noRatings: 'No ratings yet',
      mobileModalHeader: 'Add your rating',
      yourRatingReset: 'Reset your vote',
      averageRating: 'Povprečna ocena',
      reset: 'Ponastavi',
    },

    share: {
      share: 'Deli prek',
      copy: 'Kopiraj povezavo',
    },

    sort: {
      sort: 'Razvrsti',
    },

    supportLink: 'support@recright.com',

    typeSelect: {
      selected: 'Izbrano',
      change: 'Spremeni',
    },

    video: {
      videoNotFound: 'Video je v obdelavi, ali ni bil najden',
      retry: 'Poskusi ponovno',
      originalLanguageLabel: 'Izvirnik',
      englishLanguageLabel: 'Angleščina',
    },

    videoUpload: {
      uploadPlaceholder: isMobile => (isMobile ? 'Naložite ali posnemite nov video' : 'Izberi datoteko'),
      videoPlaceholder: 'Posnemite svoj odgovor',
      uploadPlaceholderCandidate: 'Naloži video',
      submit: 'Pošlji odgovor',
      notAnswered: 'Zaenkrat še niste odgovorili',
      remove: 'Odstrani posnetek',
      converting: 'Video se pretvarja. Prosimo, počakajte…',
      uploading: 'Video se nalaga. Prosimo, počakajte…',
      error: {
        invalid: 'Izbrana datoteka je prevelika. Prosimo, izberite drugo datoteko.',
        upload: 'Videoposnetka žal ni bilo mogoče naložiti. Prosimo, poskusite ponovno.',
        transcode: 'Izbrana video datoteka je bila pokvarjena ali neveljavna, prosimo, poskusite ponovno.',
      },
    },

    virtualBg: {
      showMoreButtonText: 'Pokaži več',
      showLessButtonText: 'Prikaži manj',
      infoText1:
        'Med snemanjem naj bo zavihek aktiven v ospredju. Med snemanjem ne smete uporabljati nobene druge aplikacije.',
      infoText2:
        'Video ozadja za videoposnetke najbolje delujejo v najnovejših brskalnikih in z napravami, ki so razmeroma nove in zmogljive.',
      infoText3:
        'Prepričajte se, da druge aplikacije ne uporabljajo vašega mikrofona ali kamere.',
    },

    videoResponse: {
      videoPlaceholder: 'Navedite svoj odgovor',
      uploadPlaceholder: 'Naloži video',
      submit: 'Pošlji odgovor',
      notAnswered: 'Zaenkrat še niste odgovorili',
      required: 'To vprašanje zahteva odgovor',
      startInterview: 'Začni razgovor',
    },

    webcam: {
      useVideoBgButtonText: 'Uporabi ozadje za videoposnetek',
      removeVideoBgButtonText: 'Odstrani ozadje za videoposnetek',
      starting: 'Zagon…',
      close: 'Zapri kamero',
      remove: 'Odstrani posnetek',
      record: 'Posnemi',
      stop: 'Ustavi',
      retake: 'Ponovno posnemi odgovor',
      submit: 'Pošlji odgovor',
      converting: 'Video se pretvarja. Prosimo, počakajte…',
      uploading: 'Video se nalaga. Prosimo, počakajte…',
      downloading: 'Video se prenaša. Prosimo, počakajte…',
      processing: 'Obdelovanje…',
      uploadInProgress: 'Video prenos še vedno poteka, ne zaprite brskalnika ali spremenite strani.',
      uploaded: 'Video prenesen.',
      error: {
        DevicesNotFoundError: 'Kamere ali mikrofona ni bilo mogoče uporabiti. Prosimo, preverite, da sta omogočena.',
        NotFoundError: 'Kamere ali mikrofona ni bilo mogoče uporabiti. Prosimo, preverite, da sta omogočena.',
        NotAllowedError: 'Niste podali dovoljenja za uporabo kamere ali mikrofona.',
        PermissionDismissedError: 'Zavrnili ste dialog za dovoljenje. Prosimo, podajte dovoljenje za uporabo kamere in mikrofona.',
        PermissionDeniedError: 'Zavrnili ste dostop do kamere ali mikrofona.',
        NotReadableError: 'Pretočnega predvajanja prek kamere ali mikrofona ni mogoče prebrati. Morebitna napaka strojne opreme.',
        SecurityError: 'Kamere ali mikrofona ni mogoče uporabljati zaradi varnostne napake',
        stream: 'Prišlo je do napake. Prosimo, ponovno zaženite brskalnik. V primeru, da napaka ne izgine, prosimo, poskusite z drugim brskalnikom.',
        download: 'Prenos videoposnetka ni uspel. Želite poskusiti znova?',
        upload: 'Nalaganje videoposnetka ni uspelo. Želite poskusiti znova?',
        emptyBlob: 'Vaš brskalnik ali pomnilnik naprave je poln in ne more ustvariti posnetka. Prosimo osvežite stran, če to ne pomaga pa ponovno zaženite brskalnik. V primeru, da napaka ne izgine, prosimo, poskusite z drugim brskalnikom.',
        alternativeRecorder: 'Lahko naložite datoteko s klikom na to.',
        reconnecting: 'Povezava je bila prekinjena. Poskus ponovne povezave.',
      },
    },

    smsMessages: {
      invitationMessage: title =>
        `Pozdravljeni! Želimo vas povabiti na video razgovor »${title}«. To povabilo je bilo poslano tudi na vaš e-poštni naslov. `,
    },
  },
  page: {
    interviewPreview: {
      info: 'This is a preview of the interview. Video recording is disabled and the form data is not saved.',
    },
  },
}
